import { Heading } from '@zillow/constellation-10';

import { css, cx } from '@/styled-system/css';
import { shimmerStyles } from '../styles/ShimmerStyles';

import type { HeadingPropsInterface } from '@zillow/constellation-10';

export const LoadingHeading = ({
  isLoading,
  loadingWidth,
  children,
  css: cssProp,
  style: styleProp,
  className,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth?: string;
} & Omit<HeadingPropsInterface, 'ref'>) => (
  <Heading
    data-loading={isLoading || null}
    className={cx(css(shimmerStyles, cssProp), className)}
    style={isLoading ? { width: loadingWidth ? loadingWidth : '100%', ...styleProp } : { ...styleProp }}
    {...rest}
  >
    {isLoading ? <span aria-hidden="true">&nbsp;</span> : children}
  </Heading>
);
